const FORMATION_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * A formation date is valid when it is a real YYYY-MM-DD calendar date that is
 * not in the future. All comparisons are UTC so a user's timezone never shifts
 * the day. `now` is supplied by the caller — the rulebook reads no clock.
 */
export function isValidFormationDate(value: string, now: Date): boolean {
  if (typeof value !== "string") return false;
  if (!(now instanceof Date) || Number.isNaN(now.getTime())) return false;

  const trimmed = value.trim();
  if (!FORMATION_DATE_PATTERN.test(trimmed)) return false;

  const [year, month, day] = trimmed.split("-").map(Number);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  if (Number.isNaN(parsed.getTime())) return false;

  // Round-trip guard: Date.UTC happily rolls 2024-02-31 over into March.
  if (
    parsed.getUTCFullYear() !== year ||
    parsed.getUTCMonth() !== month - 1 ||
    parsed.getUTCDate() !== day
  ) {
    return false;
  }

  const todayUTC = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
  );
  return parsed.getTime() <= todayUTC;
}
